import { Component, HostBinding, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { take } from 'rxjs/operators';

import { CalendarState } from '../lib/calendar-state';
import {
  CALENDAR_LOCALIZATION_SERVICE,
  LocalizedMonthNamesService,
} from '../lib/localized-month-names.service';

@Component({
  selector: 'pg-calendar-actions, grit-calendar-actions',
  templateUrl: './pg-calendar-actions.component.html',
  styleUrls: ['./pg-calendar-actions.component.scss'],
  exportAs: 'gritCalendarActions',
})
export class PgCalendarActionsComponent implements OnInit {
  dateDropdownFg: FormGroup;
  yearsArray = [];
  // array of digits 0-11, we use javascript month indexing where 0 = January ... 11 = December
  monthIndexes = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
  @HostBinding('class.calendar-padding')
  _paddingClass = true;
  constructor(
    private _fb: FormBuilder,
    public calendarState: CalendarState,
    @Inject(CALENDAR_LOCALIZATION_SERVICE)
    public monthsSvc: LocalizedMonthNamesService
  ) {}

  ngOnInit() {
    for (let i = 0; i < 200; i++) {
      this.yearsArray.push(1900 + i);
    }
    this.calendarState.openCalendarMonth
      .asObservable()
      .pipe(take(1))
      .subscribe(openDate => {
        this.dateDropdownFg = this._fb.group({
          month: [openDate.getMonth()],
          year: [openDate.getFullYear()],
        });

        this.dateDropdownFg.valueChanges.subscribe(value => {
          const date = this._getDateFromForm();
          this.calendarState.openCalendarMonth.next(date);
        });
      });
  }

  handleBackArrowClicked() {
    const date = this._getDateFromForm();
    date.setMonth(date.getMonth() - 1);
    this._setDateValueInForm(date);
  }

  handleFrontArrowClicked() {
    const date = this._getDateFromForm();
    date.setMonth(date.getMonth() + 1);
    this._setDateValueInForm(date);
  }

  private _getDateFromForm() {
    const formValue = this.dateDropdownFg.value;
    const date = new Date(formValue.year, formValue.month);
    return date;
  }

  private _setDateValueInForm(date: Date) {
    this.dateDropdownFg.setValue({
      month: date.getMonth(),
      year: date.getFullYear(),
    });
  }
}
